import React from "react";
import { Box, Typography, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { remCalc } from "../../../utils/helpers";

const useStyles = makeStyles(theme => ({
  header: {
    height: remCalc(80),
    borderBottom: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    position: "relative",
    backgroundColor: "#fff",
    flexShrink: 0,
    boxSizing: "border-box"
  },
  mainTitle: {
    fontWeight: "500",
    fontSize: "1.25rem",
    lineHeight: "1.4375rem"
  },
  closeBtn: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2)
  }
}));

function PricingHeader({ title, handleClose }) {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center" className={classes.header}>
      <Typography variant="h6" className={classes.mainTitle}>
        {title}
      </Typography>

      <IconButton
        edge="start"
        color="default"
        onClick={() => {
          handleClose();
        }}
        data-cy="closePricing"
        aria-label="close"
        className={classes.closeBtn}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
}

export default PricingHeader;
